import React from "react";
import styles from "./Footer.module.css";
import { APP_VERSION } from "../../api/config";
import { Icon } from '@brand';
import { getBrandConfig } from '../../brands/brand-registry';

const Footer: React.FC = () => {
  // Get brand configuration for dynamic logo and link
  const brandId = import.meta.env.VITE_BRAND_ID;
  if (!brandId) {
    throw new Error('VITE_BRAND_ID environment variable is required');
  }
  const brandConfig = getBrandConfig(brandId);
  
  // Get brand-specific link and copyright name
  const brandLink = brandId === 'udaras' 
    ? 'https://www.udaras.ie/' 
    : 'https://www.citizensinformation.ie/en/';
  
  const brandTitle = brandId === 'udaras' 
    ? 'Údarás na Gaeltachta link' 
    : 'Citizens Information link';
  
  const brandCopyrightName = brandId === 'udaras' 
    ? 'Údarás na Gaeltachta' 
    : 'Citizens Information Board';

  // Apply brand-specific styling
  const footerClassName = brandId === 'udaras' 
    ? `${styles.footer} ${styles.footerUdaras}` 
    : styles.footer;

  return (
    <footer className={footerClassName}>
      <div className={styles.left}>App Version: {APP_VERSION}</div>
      <div className={styles.center}>
        &copy; {new Date().getFullYear()} {brandCopyrightName} - All Rights Reserved
      </div>
      <div className={styles.right}>
        <a
          href={brandLink}
          target={"_blank"}
          title={brandTitle}
          className={styles.footer_icon}
        >
          <div className={styles.logo}>
            <Icon width={32} height={32} />
          </div>
        </a>
      </div>
    </footer>
  );
};

export default Footer;
